// @owners { team: patients }
import { SPACING } from '@alto/design-library-tokens';
import { ActionSheetContext, ActionSheetV2, Body, Button, LgPadding, Link, MdSpacing } from '@alto/design-system';
import { useNavigation } from '@alto/navigation';
import React, { useContext, useEffect } from 'react';
import { Link as RRLink } from 'react-router-dom';
import { sendNewYorkFertilityNeedlePromptViewed } from '~shared/actions/checkout';
import { getImage } from '~shared/assets/images/getImage';
import { getImageAltText } from '~shared/assets/images/getImageAltText';
import { getEnterCartData } from '~shared/features/checkout/selectors/getCheckoutFlow';
import { formatList } from '~shared/helpers/list';
import { useDispatchShared, useSelectorShared } from '~shared/store';

export const MissingNeedlesActionSheet = () => {
  const { navigate } = useNavigation();
  const dispatch = useDispatchShared();
  const { closeActionSheet } = useContext(ActionSheetContext);

  const enterCartData = useSelectorShared(getEnterCartData);
  const requireNeedlePrescriptions = enterCartData?.needle_prompt_no_needles?.require_needle_prescriptions ?? [];

  const requireMedicationNames = () => {
    const medicationNames = requireNeedlePrescriptions.map(
      (medication: { medication_name: string }) => medication.medication_name,
    );

    return formatList(medicationNames);
  };

  useEffect(() => {
    dispatch(sendNewYorkFertilityNeedlePromptViewed());
  }, [dispatch, enterCartData]);

  return (
    <ActionSheetV2
      title="Missing needles?"
      analyticsName="missing_needles"
      illustrationSrc={getImage('needleMeds')}
      illustrationAccessibilityLabel={getImageAltText('needleMeds')}
      buttons={[
        <Button
          key="got_it_button"
          label="Got it"
          accessibilityLabel="Got it"
          onPress={() => {
            closeActionSheet();
            navigate('RouteCheckout');
          }}
        />,
      ]}
    >
      <LgPadding
        topPadding={SPACING.STATIC.NONE}
        bottomPadding={SPACING.STATIC.NONE}
      >
        <Body>Your {requireMedicationNames()} will not come with needles.</Body>
        <MdSpacing />
        <Body>
          If you need needles or are out of refills, you can request more from an existing needle prescription on your
          profile,
          {' or '}
          <RRLink to="/messages">
            <Link onPress={closeActionSheet}>message us</Link>
          </RRLink>{' '}
          for assistance.
        </Body>
      </LgPadding>
    </ActionSheetV2>
  );
};
